import { render } from "./NewOrderPickup.vue?vue&type=template&id=5310e51a&ts=true"
import script from "./NewOrderPickup.ts?vue&type=script&lang=ts"
export * from "./NewOrderPickup.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__